export default "__VITE_PUBLIC_ASSET__b90cd515__"